@let isErrorOccurred = errorNotificationService.isErrorOccurred$ | async;

<mm-navigation [activeNavigation]="'scoreboard'"></mm-navigation>
<div class="micromate-learn-component"
     [class.micromate-learn-component-dev-error]="isErrorOccurred !== null && isErrorOccurred !== undefined && isErrorOccurred === true">
    <div class="micromate-learn-context">
        <mm-ranking
            [darkMode]="false"
            (periodSelected)="periodSelected($event)"
            [rankingData]="scoreboardData$">
        </mm-ranking>
    </div>

</div>


